import React from 'react';
import { TextField, Menu, Grid, Typography } from '@mui/material';
import DatePicker from 'react-datepicker';
import { CalendarIcon } from '../../../assets/images/UI-dashboard';
import { CustomDatePickerWrapper } from '../ScenarioLibrary.Styled';

interface DateSelectProps {
  dateRange: [Date | null, Date | null];
  handleDateChange: (start: Date | null, end: Date | null) => void;
  handleCalendarOpen: (event: React.MouseEvent<HTMLElement>) => void;
  handleCalendarClose: () => void;
  calendarAnchorEl: HTMLElement | null;
}

const validateDate = (date: Date | null): Date | null => {
  return date && !isNaN(date.getTime()) ? date : null;
};

const DateSelect: React.FC<DateSelectProps> = ({
  dateRange,
  handleDateChange,
  handleCalendarOpen,
  handleCalendarClose,
  calendarAnchorEl,
}) => (
  <Grid
    style={{
      display: 'flex',
      alignItems: 'center',
      marginLeft: '10px',
      marginRight: '20px',
    }}
  >
    <Typography
      style={{
        fontWeight: 600,
        fontSize: '10.89px',
        lineHeight: '13.28px',
        marginRight: '5px',
        whiteSpace: 'nowrap',
      }}
    >
      Select Date:{' '}
    </Typography>
    <div
      style={{
        border: '0.91px solid #ECECEC',
        height: '24px',
        display: 'flex',
        borderRadius: '4px',
      }}
    >
      <TextField
        placeholder="Start date"
        style={{ width: '100px' }}
        value={dateRange[0]?.toLocaleDateString() || ''}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          width: '400px',
          '& .MuiOutlinedInput-root': {
            height: '22px',
            borderRadius: '10px',
            border: 'none',
            boxShadow: 'none',
            fontSize: '10px',
            '& fieldset': {
              border: 'none',
            },
            '&:hover fieldset': {
              border: 'none',
            },
            '&.Mui-focused fieldset': {
              border: 'none',
            },
          },
        }}
      />
      <hr style={{ height: '23px', opacity: '70%' }} />
      <TextField
        placeholder="End date"
        style={{ width: '100px' }}
        value={dateRange[1]?.toLocaleDateString() || ''}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          width: '400px',
          '& .MuiOutlinedInput-root': {
            height: '22px',
            borderRadius: '10px',
            border: 'none',
            boxShadow: 'none',
            fontSize: '10px',
            '& fieldset': {
              border: 'none',
            },
            '&:hover fieldset': {
              border: 'none',
            },
            '&.Mui-focused fieldset': {
              border: 'none',
            },
          },
        }}
      />
      <div
        style={{
          background: '#DF2020',
          width: '22px',
          height: '24px',
          cursor: 'pointer',
          borderTopRightRadius: '4px',
          borderBottomRightRadius: '4px',
        }}
      >
        <img
          src={CalendarIcon}
          alt="calendar-icon"
          style={{ cursor: 'pointer', marginLeft: '5px' }}
          onClick={handleCalendarOpen}
        />
      </div>
    </div>
    <Menu
      anchorEl={calendarAnchorEl}
      open={Boolean(calendarAnchorEl)}
      onClose={handleCalendarClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <CustomDatePickerWrapper>
        <Grid style={{ display: 'flex', padding: '10px' }}>
          <DatePicker
            selected={validateDate(dateRange[0])}
            onChange={(start) => handleDateChange(start, dateRange[1])}
            inline
            selectsStart
            startDate={dateRange[0]}
            endDate={dateRange[1]}
          />
          <DatePicker
            selected={validateDate(dateRange[1])}
            onChange={(end) => handleDateChange(dateRange[0], end)}
            inline
            selectsEnd
            startDate={dateRange[0]}
            endDate={dateRange[1]}
          />
        </Grid>
      </CustomDatePickerWrapper>
    </Menu>
  </Grid>
);

export default DateSelect;
